export enum BriefOutcome {
  OUTCOME_TRUE_REVISION_UP = 1001,
  OUTCOME_TRUE_REVISION_DOWN = 1002,
  OUTCOME_TRUE_90D_HIGH = 1001,
  OUTCOME_TRUE_90D_LOW = 1002,
  OUTCOME_TRUE_REVENUE_UPGRADE = 1001,
  OUTCOME_TRUE_REVENUE_DOWNGRADE = 1002,
  OUTCOME_TRUE_EPS_UPGRADE = 1003,
  OUTCOME_TRUE_EPS_DOWNGRADE = 1004,
  OUTCOME_TRUE_MIXED_REVISION = 1005,
  OUTCOME_TRUE_INSIDER_BUY = 1001,
  OUTCOME_TRUE_INSIDER_SELL = 1002,
  OUTCOME_TRUE_PRICE_MOVE_UP = 1001,
  OUTCOME_TRUE_PRICE_MOVE_DOWN = 1002,
  OUTCOME_TRUE_NO_MISALIGNMENT = 1001,
  OUTCOME_TRUE_EPS_MISALIGNMENT = 1002,
  OUTCOME_TRUE_REVENUE_MISALIGNMENT = 1003,
  OUTCOME_TRUE_POSITIVE_RESULT = 1001,
  OUTCOME_TRUE_NEUTRAL_RESULT = 1002,
  OUTCOME_TRUE_NEGATIVE_RESULT = 1003,
  OUTCOME_TRUE_BREAK_EVEN_GOOD = 1001,
  OUTCOME_TRUE_BREAK_EVEN_BAD = 1002,
  OUTCOME_TRUE_FINANCIAL_DATA_MINOR = 1002,
  OUTCOME_TRUE_FINANCIAL_POSITION_MINOR = 1003,
  OUTCOME_TRUE_STABLE_PRICE_MINOR = 1004,
  OUTCOME_TRUE_NEGATIVE_EQUITY_MINOR = 1005,
  OUTCOME_TRUE_DIVIDEND_SUSTAINABLE_MINOR = 1006,
  OUTCOME_TRUE_PROFITABILITY_MINOR = 1007,
  OUTCOME_TRUE_EARNINGS_QUALITY_MINOR = 1009,
  OUTCOME_TRUE_PROFIT_MARGIN_MINOR = 1010,
  OUTCOME_TRUE_DILUTION_MINOR = 1011,
  OUTCOME_TRUE_INSIDER_SELLING_MINOR = 1012,
  OUTCOME_TRUE_MEANINGFUL_REVENUE_MINOR = 1013,
  OUTCOME_TRUE_MEANINGFUL_MKT_CAP_MINOR = 1014,
  OUTCOME_TRUE_CONCERNING_EVENTS_MAJOR = 1101,
  OUTCOME_TRUE_FINANCIAL_DATA_MAJOR = 1102,
  OUTCOME_TRUE_FINANCIAL_POSITION_MAJOR = 1103,
  OUTCOME_TRUE_STABLE_PRICE_MAJOR = 1104,
  OUTCOME_TRUE_NEGATIVE_EQUITY_MAJOR = 1105,
  OUTCOME_TRUE_DIVIDEND_SUSTAINABLE_MAJOR = 1106,
  OUTCOME_TRUE_REVENUE_EARNINGS_GROWTH_MAJOR = 1108,
  OUTCOME_TRUE_EARNINGS_QUALITY_MAJOR = 1109,
  OUTCOME_TRUE_DILUTION_MAJOR = 1111,
  OUTCOME_TRUE_MEANINGFUL_REVENUE_MAJOR = 1113,
  OUTCOME_TRUE_MEANINGFUL_MKT_CAP_MAJOR = 1114,
  OUTCOME_TRUE_DIVIDEND_DECREASE = 1001,
  OUTCOME_TRUE_DIVIDEND_INCREASE = 1002,
  OUTCOME_TRUE_DIVIDEND_AFFIRMATION = 1003,
  OUTCOME_TRUE_DIVIDEND_CHANGE_UNCERTAIN = 1004,
  OUTCOME_TRUE_UNDERVALUED = 1001,
  OUTCOME_TRUE_OVERVALUED = 1002,
}

export enum BriefType {
  HasUpcomingDividend = 'HasUpcomingDividend',
  IsNew90DayHighLow = 'IsNew90DayHighLow',
  HasPriceTargetChanged = 'HasPriceTargetChanged',
  HasReportedEarnings = 'HasReportedEarnings',
  HasMajorEstimateRevision = 'HasMajorEstimateRevision',
  HasRecentInsiderTransactions = 'HasRecentInsiderTransactions',
  ValuationUpdateWith7DayPriceMove = 'ValuationUpdateWith7DayPriceMove',
  AnalystEstimateSurprisePostEarnings = 'AnalystEstimateSurprisePostEarnings',
  HasRecentInsiderTransactionsDerivative = 'HasRecentInsiderTransactionsDerivative',
  HasExecutiveDeparture = 'HasExecutiveDeparture',
  HasBreakevenDateChange = 'HasBreakevenDateChange',
  BoardChange = 'BoardChange',
  HasDirectorOverboarding = 'HasDirectorOverboarding',
  BuyOrSellOpportunity = 'BuyOrSellOpportunity',
  HasNewRisk = 'HasNewRisk',
  HasDeclaredDividend = 'HasDeclaredDividend',
  BuyingOpportunity = 'BuyingOpportunity',
}

export type BriefColorVariants =
  | 'good'
  | 'bad'
  | 'neutral'
  | 'warning'
  | 'default';
